module.exports = __webpack_public_path__ + "ag.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ag.svg
// module id = 665
// module chunks = 0